import { AdminRoutePath } from "../routes/routePath";
import ImagesUrl from "./images";
const adminSidebarConfig = () => [
  {
    title: AdminRoutePath.DASHBOARD.title,
    Icon: ImagesUrl.dashboard,
    path: AdminRoutePath.DASHBOARD.path,
  },
  {
    title: AdminRoutePath.AGRONOMIST_MANAGEMENT.title,
    Icon: ImagesUrl.agronomist,
    path: AdminRoutePath.AGRONOMIST_MANAGEMENT.path,
  },
  // {
  //   title: AdminRoutePath.SCOUTING_MANAGEMENT.title,
  //   Icon: ImagesUrl.scout,
  //   path: AdminRoutePath.SCOUTING_MANAGEMENT.path,
  // },
  // {
  //   title: AdminRoutePath.CROP_PLAN_MANAGEMENT.title,
  //   Icon: ImagesUrl.crop,
  //   path: AdminRoutePath.CROP_PLAN_MANAGEMENT.path,
  // },
  // {
  //   title: AdminRoutePath.GROWERS_MANAGEMENT.title,
  //   Icon: ImagesUrl.growers,
  //   path: AdminRoutePath.GROWERS_MANAGEMENT.path,
  // },
  {
    title: AdminRoutePath.CROP_MANAGEMENT.title,
    Icon: ImagesUrl.crop,
    path: AdminRoutePath.CROP_MANAGEMENT.path,
  },
  {
    title: AdminRoutePath.PRODUCT_MANAGEMENT.title,
    Icon: ImagesUrl.product,
    path: AdminRoutePath.PRODUCT_MANAGEMENT.path,
  },
  {
    title: AdminRoutePath.CONTENT_MANAGEMENT.title,
    Icon: ImagesUrl.content,
    path: AdminRoutePath.CONTENT_MANAGEMENT.path,
  },
];

export default adminSidebarConfig;
